<template>
  <div class="home">
    <h1>
      <div>{{'homeTitle1' | localize}}&nbsp;</div>
      <div>{{'homeTitle2' | localize}}&nbsp;</div>
      <div v-if="locale == 'ru'">{{'homeTitle3' | localize}}&nbsp;</div>
    </h1>
    <p>
      {{'aboutUs' | localize}}
      <b>{{'niceToMeet' | localize}}</b>
      {{'itsMe' | localize}}
    </p>
    <br />
    <div class="text-center">
      <a href="#contacts" class="btn-primary margin-5" v-smooth-scroll>{{'writeUs' | localize}}</a>
      <a :href="'projectsLink' | localize" class="btn-primary margin-5">{{'ourProjects' | localize}}</a>
    </div>
    <div class="home__image">
      <img src="/img/mobile/home/page1.svg" alt="page1" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeMobile",
  props: {},
  data: () => ({
    locale: "",
  }),
  mounted() {
    this.locale = localStorage.getItem("locale");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.home {
  @extend .text-center;
  position: relative;
  padding: $padding__block;
  padding-top: 110px;

  &__image {
    margin-top: 45px;

    img {
      width: 100%;
      max-width: 480px;
    }
  }
}
</style>
